export default {
    "content": "This is some {type} content"
};